export const windowLocationOrigin = typeof window !== "undefined" && window.location.origin || 'https://www.divissa.com.tr';





const backendUrl = windowLocationOrigin.includes('localhost') ||
    windowLocationOrigin.includes('devissa.com')
    ? 'http://api.devissa.com'
    : windowLocationOrigin.includes('previssa.com')
        ? 'https://api.previssa.com'
        : windowLocationOrigin.includes('divissa.com.tr')
            ? 'https://api.divissa.com.tr'
            : 'http://api.devissa.com';
 
export const callbackUrl = windowLocationOrigin + '/odeme-sonuc';
export const API_BASE_URL = `${backendUrl}/api/v1/`;
export const API_BASE = backendUrl;

// Diğer configler

export const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const recaptchasSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
export const googleSignInClientId = import.meta.env.VITE_GOOGLE_SIGN_IN_CLIENT_ID;
export const googleCalendarApiKey = import.meta.env.VITE_GOOGLE_CALENDAR_API_KEY;
export const dsnAddress = import.meta.env.VITE_SENTRY_DSN;

